"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var moment_1 = __importDefault(require("moment"));
require("moment/locale/fi");
require("moment/locale/sv");
var StyledDiv_1 = __importDefault(require("../StyledDiv"));
var Date = function (_a) {
    var styles = _a.styles, id = _a.id, effects = _a.effects, dateOptions = _a.dateOptions;
    return (react_1.default.createElement(StyledDiv_1.default, { id: id, styles: styles, effects: effects }, (dateOptions === null || dateOptions === void 0 ? void 0 : dateOptions.locale)
        ? (0, moment_1.default)().locale(dateOptions.locale).format(dateOptions === null || dateOptions === void 0 ? void 0 : dateOptions.format)
        : (0, moment_1.default)().format(dateOptions === null || dateOptions === void 0 ? void 0 : dateOptions.format)));
};
exports.default = Date;
//# sourceMappingURL=Date.js.map